import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "Actions";
import NumberInput from "Utils/NumberInput";
import { saveError } from "Api";
import { apiToSingularConnections } from "Constants/displayConstants";
import SerializedMoveModal from "./SerializedMoveModal";
import validations from "HelperFunctions/validations";
import Endpoints from "Api/endpoints";
import classnames from "classnames";

class MoveInventoryContainer extends Component {
  state = {
    toProductId: "",
    movingQuantity: "",
    serializedMoveOpen: false,
    movingIds: []
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  };

  validate = () => {
    const errors = {};
    const { product } = this.props;
    const { toProductId, movingQuantity } = this.state;
    if (validations.required(toProductId, true)) {
      errors.toProductId = "Please select a location to move inventory to";
    }
    if (Number(movingQuantity) <= 0) {
      errors.movingQuantity = "Invalid moving quantity.";
    }
    if (Number(movingQuantity) > product.quantity) {
      errors.movingQuantity =
        "You can't move more than you have in the inventory.";
    }
    return errors;
  };

  moveInventory = () => {
    const { product } = this.props;
    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.props.setErrors(errors);
    } else {
      if (product.serializationStatus === "serialized") {
        this.moveSerializedInventory();
      } else {
        this.moveStandardInventory();
      }
    }
  };

  moveStandardInventory = () => {
    const { product, productType } = this.props;
    const { movingQuantity, toProductId } = this.state;

    const component = this;
    const data = {
      from_id: product.id,
      to_id: toProductId,
      moving_quantity: movingQuantity
    };
    Endpoints.multilocation.inventoryGroups
      .moveInventory(productType, data)
      .then(response => {
        component.props.fetchProduct(
          apiToSingularConnections[productType],
          this.props.product.id
        );
        component.setState({
          toProductId: "",
          movingQuantity: ""
        });
      })
      .catch(error => {
        saveError(error);
        component.props.setErrors(error.response.data);
      });
  };

  moveSerializedInventory = () => {
    const { product, productType } = this.props;
    const { toProductId, movingIds } = this.state;

    const component = this;
    const data = {
      from_id: product.id,
      to_id: toProductId,
      moving_ids: movingIds
    };
    Endpoints.multilocation.inventoryGroups
      .moveSerializedInventory(productType, data)
      .then(response => {
        component.props.fetchProduct(
          apiToSingularConnections[productType],
          this.props.product.id
        );
        component.setState({
          toProductId: "",
          movingQuantity: "",
          movingIds: []
        });
      })
      .catch(error => {
        saveError(error);
        component.props.setErrors(error.response.data);
      });
  };
  handleCancelClick = () => {
    const { product, productType } = this.props;
    const {
      openLoadingSpinner,
      closeLoadingSpinner,
      setProductFromResponse,
      setErrors
    } = this.props;

    openLoadingSpinner("Unlinking Item to Group...");
    Endpoints.multilocation.products
      .disconnectToGroup(product, productType)
      .then(response => {
        closeLoadingSpinner();
        setProductFromResponse(
          apiToSingularConnections[productType],
          product.id,
          response
        );
      })
      .catch(error => {
        closeLoadingSpinner();
        this.setState({
          disableModalOpen: false,
          checks: [false, false, false, false]
        });
        saveError(error);
        setErrors(error.response.data);
      });
  };

  handleMovingIdsSelect = movingIds => {
    this.setState({
      movingIds: movingIds,
      movingQuantity: movingIds.length
    });
  };

  toggleSerializedMove = () => {
    this.setState({
      serializedMoveOpen: !this.state.serializedMoveOpen
    });
  };

  render() {
    const { errors, product } = this.props;
    const { movingQuantity, toProductId, serializedMoveOpen } = this.state;

    return (
      <section className="moveInventory">
        <h4>Move Inventory From My Warehouse To</h4>
        <div className="form">
          <div className="fields">
            <label className="lg">
              {product.serializationStatus === "serialized"
                ? "Scan Items"
                : "Quantity"}
            </label>
            {product.serializationStatus === "serialized" ? (
              <input
                type="text"
                className="med barcode"
                onClick={this.toggleSerializedMove}
              />
            ) : (
              <NumberInput
                className={classnames({
                  med: true,
                  error: errors.movingQuantity
                })}
                name="movingQuantity"
                type="text"
                value={movingQuantity}
                onChange={this.handleChange}
              />
            )}
            <select
              className={classnames({
                error: errors.toProductId
              })}
              name="toProductId"
              value={toProductId}
              onChange={this.handleChange}
            >
              <option value="">
                Select a location to move inventory to...
              </option>
              {product.groupInfo &&
                product.groupInfo.sharedInventory.map(
                  (sharedProduct, index) =>
                    sharedProduct.id !== product.id && (
                      <option key={sharedProduct.id} value={sharedProduct.id}>
                        {sharedProduct.locationName}
                        {sharedProduct.locationCode &&
                          " (" + sharedProduct.locationCode + ")"}
                      </option>
                    )
                )}
            </select>
          </div>
          <div className="actions">
            <a
              id="move_inventory_submit"
              className="btn"
              onClick={this.moveInventory}
            >
              Submit
            </a>
            <a className="btn cancel" onClick={this.handleCancelClick}>
              Cancel
            </a>
          </div>
        </div>
        <SerializedMoveModal
          product={product}
          open={serializedMoveOpen}
          toggle={this.toggleSerializedMove}
          onMovingIdsSelect={this.handleMovingIdsSelect}
        />
      </section>
    );
  }
}

const mapStateToProps = state => {
  const { errors } = state.dashboard;

  return { errors };
};
export default connect(mapStateToProps, actions)(MoveInventoryContainer);
